/**
 * Notification Service - Epic 47
 * API calls for MASTER user notifications
 */
import apiClient from './apiClient';

export interface NotificacaoConteudo {
  cliente_nome: string;
  cliente_codigo: string;
  hospital_nome: string;
  data_agendamento: string;
  tipo_violacao: 'ABAIXO_MINIMO' | 'ACIMA_MAXIMO';
  tipo_violacao_display: string;
  intervalo_configurado: number;
  intervalo_atual: number;
  data_ultima_contagem: string | null;
  observacao_completa: string;
  aprovado_por_nome: string;
  aprovado_por_email: string;
  job_id: number;
}

export interface Notificacao {
  id: number;
  notificacao_id: number;
  tipo: string;
  titulo: string;
  descricao_curta: string;
  preview_observacao: string;
  conteudo: NotificacaoConteudo;
  job_id: number | null;
  cliente_id: number;
  cliente_nome: string;
  lida: boolean;
  data_leitura: string | null;
  created_at: string;
  tempo_relativo: string;
}

export interface NotificacaoCountResponse {
  count: number;
}

export interface NotificacaoListResponse {
  notificacoes: Notificacao[];
  total: number;
}

/**
 * Get all notifications for the current MASTER user
 * Note: Backend returns array directly, we wrap it in expected format
 */
export const getNotificacoes = async (): Promise<NotificacaoListResponse> => {
  const response = await apiClient.get<Notificacao[]>('/notificacoes/');
  // Backend returns array directly, wrap in expected format
  const notificacoes = response.data || [];
  return {
    notificacoes,
    total: notificacoes.length,
  };
};

/**
 * Get unread notification count for the current MASTER user
 */
export const getNotificacaoCount = async (): Promise<NotificacaoCountResponse> => {
  const response = await apiClient.get<NotificacaoCountResponse>('/notificacoes/count');
  return response.data;
};

/**
 * Get notification details and mark as read
 */
export const getNotificacaoDetail = async (id: number): Promise<Notificacao> => {
  const response = await apiClient.get<Notificacao>(`/notificacoes/${id}`);
  return response.data;
};

/**
 * Toggle notification read/unread status
 */
export const toggleNotificacaoLeitura = async (id: number): Promise<Notificacao> => {
  const response = await apiClient.patch<Notificacao>(`/notificacoes/${id}/toggle-leitura`);
  return response.data;
};

export default {
  getNotificacoes,
  getNotificacaoCount,
  getNotificacaoDetail,
  toggleNotificacaoLeitura,
};
